module.exports = isThunk

function isThunk(t) {
    return t && t.type === "Thunk"
}



//////////////////
// WEBPACK FOOTER
// C:/Users/tomas/OneDrive/Tomas/Materials/Talks/2018/live-compilers/code/completed/node_modules/virtual-dom/vnode/is-thunk.js
// module id = 17
// module chunks = 0